import { render, staticRenderFns } from "./MovimientoFormCompra.vue?vue&type=template&id=617236e5&scoped=true&"
import script from "./MovimientoFormCompra.vue?vue&type=script&lang=js&"
export * from "./MovimientoFormCompra.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoFormCompra.vue?vue&type=style&index=0&id=617236e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617236e5",
  null
  
)

export default component.exports